import { Component, Inject, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { Message } from '@tv3/store/message/message.model'
import * as R from 'ramda'
import { LoadInquiryDetails } from '@tv3/store/inquiry/inquiry.actions'
import { Destroyable, distinctUntilChangedByIds, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { selectMessagesByInquiryId } from '@tv3/store/message/message.selectors'
import { selectInquiry } from '@tv3/store/inquiry/inquiry.selectors'
import { switchMap, tap } from 'rxjs/operators'

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent extends Destroyable implements OnInit {
  inquiry: Inquiry

  messages: Message[] = []

  messageId?: string

  constructor(
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { inquiryId: string; messageId?: string }
  ) {
    super()
  }

  ngOnInit() {
    this.messageId = this.data.messageId
    this.store.dispatch(LoadInquiryDetails({ id: this.data.inquiryId }))

    this.store
      .pipe(
        select(selectInquiry, { id: this.data.inquiryId }),
        tap((inquiry) => (this.inquiry = inquiry)),
        switchMap((inquiry) =>
          this.store.pipe(select(selectMessagesByInquiryId(inquiry.id, inquiry.links)), distinctUntilChangedByIds())
        ),
        untilDestroy(this)
      )
      .subscribe((messages) => {
        this.messages = R.defaultTo([], messages)
      })
  }

  close() {
    this.dialogRef.close()
  }
}
